<template>
  <div>
    <promo-bar-b v-if="test === 'B'" />
    <promo-bar-c v-else-if="test === 'C'" />
    <promo-bar-d v-else-if="test === 'D'" />
    <promo-bar-e v-else-if="test === 'E'" />
    <promo-bar-f v-else-if="test === 'F'" />
  </div>
</template>

<script>
import { growthbookMixin } from '~/lib/growthbook/reactive'
import PromoBarB from '~/components/tests/promo-bar/PromoBarB'
import PromoBarC from '~/components/tests/promo-bar/PromoBarC'
import PromoBarD from '~/components/tests/promo-bar/PromoBarD'
import PromoBarE from '~/components/tests/promo-bar/PromoBarE'
import PromoBarF from '~/components/tests/promo-bar/PromoBarF'

export default {
  name: 'PromoBarTest',
  components: { PromoBarB, PromoBarC, PromoBarD, PromoBarE, PromoBarF },
  mixins: [growthbookMixin],
  computed: {
    test () {
      return this.gbValue('promo-bar')
    }
  }
}
</script>
